import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { ReceiptListProvider } from "./context";
import ManageReceipts from "./ManageReceipts";

import { PermisionDenied } from "../../../../common/commonComponents";
import { pages } from "views/pages/manage/common/constant";
import { RolePermissions, PermissionContext } from "appContext";

const ManageReceiptsWrapper = ({ centralizedRowsData = [] }) => {
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["paymentCollectionManageReceipts"]["id"]
  );

  const location = useLocation();
  const isCentralizedUser = location.pathname.includes("centralizedAdmission");

  useEffect(() => {
    // Send event to Google Analytics
    window.gtag("event", "manage-receipts", {
      event_category: "Visit Card",
      event_label: "Landed on Manage Receipt listing",
      value: 1,
    });
  }, []);
  //  ['A', 'D', 'U', 'R', 'C']

  return userPermissions ? (
    <ReceiptListProvider>
      <ManageReceipts
        isCentralizedAdm={isCentralizedUser}
        centralizedRowsData={centralizedRowsData}
        op
      />
    </ReceiptListProvider>
  ) : (
    <PermisionDenied />
  );
};

export default ManageReceiptsWrapper;
